import React, { useState } from "react";
import { Link } from "react-router-dom";
import { buildApiUrl } from "../config/api";
import "./Footer.css";

import instagramIcon from "../assets/icons/instagram-icon.png";

function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    const cleanEmail = email.trim().toLowerCase();

    if (!cleanEmail) {
      setMessage("Please enter your email address.");
      return;
    }

    try {
      setIsSubmitting(true);
      setMessage("");

      const params = new URLSearchParams(window.location.search);

      const payload = {
        email: cleanEmail,
        source: "mayachitro-footer",
        signup_page: window.location.pathname,
        referrer_url: document.referrer || null,
        landing_page: window.location.href,

        utm_source: params.get("utm_source"),
        utm_medium: params.get("utm_medium"),
        utm_campaign: params.get("utm_campaign"),
        utm_content: params.get("utm_content"),
        utm_term: params.get("utm_term"),

        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language,
        screen_size: `${window.screen.width}x${window.screen.height}`,

        consent_version: "v1.0",
        consent_text:
          "User subscribed to receive MayaChitro private releases, field notes, licensing updates, and occasional offers.",
      };

      const response = await fetch(buildApiUrl("/newsletter/subscribe"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        setMessage(data.message || "Subscription failed. Please try again.");
        return;
      }

      setMessage(data.message || "Thank you! You are on the MayaChitro update list.");
      setEmail("");
    } catch (error) {
      console.error("Newsletter submit error:", error);
      setMessage("Server error. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="mc-site-footer">
      <section className="mc-newsletter-block" aria-labelledby="mc-newsletter-title">
        <div className="mc-newsletter-copy">
          <p className="mc-footer-kicker">Private releases &amp; field notes</p>

          <h2 id="mc-newsletter-title">
            New photographs,<br />quietly delivered.
          </h2>

          <p>
            Receive first access to new collections, stories from the field,
            licensing notes, and occasional collector offers.
          </p>
        </div>

        <form className="mc-newsletter-form" onSubmit={handleNewsletterSubmit}>
          <div className="mc-newsletter-input-row">
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isSubmitting}
              required
            />

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Subscribing..." : "Subscribe"}
            </button>
          </div>

          <p className="mc-newsletter-trust">
            Free photo updates <span>•</span> Discount offers <span>•</span> No spam
          </p>

          {message && <p className="mc-newsletter-message">{message}</p>}
        </form>
      </section>

      <section className="mc-footer-main">
        <div className="mc-footer-brand">
          <Link to="/" className="mc-footer-logo">
            MayaChitro
          </Link>

          <p>
            Original, story-led photography for collectors, publishers,
            thoughtful spaces, and creative teams worldwide.
          </p>

          <div className="mc-footer-socials">
            <a href="https://www.instagram.com/maya_chitro/" target="_blank" rel="noreferrer" aria-label="MayaChitro on Instagram">
              <img src={instagramIcon} alt="" />
            </a>
          </div>
        </div>

        <div className="mc-footer-col">
          <h3>Shop</h3>
          <Link to="/shop">All Photographs</Link>
          <Link to="/shop?sort=newest">New Arrivals</Link>
          <Link to="/collections">Photography Collections</Link>
        </div>

        <div className="mc-footer-col">
          <h3>Company</h3>
          <Link to="/about">About MayaChitro</Link>
          <Link to="/stories">Photo Stories</Link>
          <Link to="/licensing">Licensing</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="mc-footer-col">
          <h3>Buyer Support</h3>
          <Link to="/how-to-download">How to Download</Link>
          <Link to="/my-downloads">My Downloads</Link>
          <Link to="/wishlist">Wishlist</Link>
          <Link to="/terms">Terms & Privacy</Link>
        </div>
      </section>

      <section className="mc-footer-bottom">
        <p>© 2026 MayaChitro. All rights reserved.</p>
        <p>Visual stories. Timeless moments. Original photography for the world.</p>
      </section>

      <section className="mc-payment-trust" aria-label="Secure payment information">
        <p><strong>Secure checkout by Stripe</strong><span>Encrypted payment · Instant digital access</span></p>
        <div className="mc-payment-marks" aria-label="Major cards accepted">
          <span>VISA</span>
          <span>Mastercard</span>
          <span>AMEX</span>
          <span>Link</span>
        </div>
      </section>
    </footer>
  );
}

export default Footer;
